import React from "react";
import Head from "next/head";

export default function DefaultMeta() {
  return (
    <Head>
      <meta charSet="utf-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <meta name="viewport" content="initial-scale = 1.0,maximum-scale = 1.0" />
      <meta httpEquiv="Content-Type" content="text/html;charset=utf-8" />
      <meta httpEquiv="X-UA-Compatible" content="IE=edge,Chrome=1" />
      <link rel="icon" href="/images/logo-symbol-dark.png" />
      <meta
        name="google-site-verification"
        content="_seYMPLlA-T9NT5cv1q95GwACeNY3re7jjVAcmL2LE8"
      />
      <meta name="author" content="Aseel" />
      <meta name="robots" content="index, follow" />
      <meta content="article" property="og:type" data-rh="true" />
      <meta
        property="og:site_name"
        content="Investment Aseel | اصيل للأستثمار"
      />
      <meta
        name="keywords"
        content="ASEEL, aseel, أصيل, investaseel, منصة أصيل, منصة اصيل, منصة استثمار, عقارات"
      />
    </Head>
  );
}
